import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SanParsedGameData } from "../../../server/data/SanParsedGameData";
import { RevealerManager } from "../../independent/revealer/RevealerManager"
import { ReavealerState, Revealer } from "../../independent/revealer/Revealer";
import { SanSpriteSymbol } from "../../../engine/Symbol/SanSpriteSymbol";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { TimelineMax, TweenLite } from "gsap";
import { XWaysCounter } from "../../independent/countup/XWaysCounter";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { SanGameConfig } from "../../../SanGameConfig";
import { JumpingWildCollector } from "../../independent/collector/JumpingWildCollector";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import {IReelSpriteSymbol} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/IReelSpriteSymbol";

export class ScatterRevealPresentation extends Presentation {

    private gameData:SanParsedGameData;

    private reelRevealIndex:number = 0;

    public setParsedGamedData(data: SanParsedGameData): void {
        this.gameData = data;

        this.reelRevealIndex = 0;

        if(data.scatterAmount == 1){
            for(let i:number = 0; i < this.gameData.scatterReelPositions.length;i++){
                if(this.gameData.scatterReelPositions[i] >= 0){
                    this.reelRevealIndex = i;
                    break;
                }
            }
        }
    }

    public checkForActivation(data:SanParsedGameData):boolean{
        return data.scatterAmount > 0 && data.mode === GameMode.NORMAL && data.nextMode != "FREESPIN_SETUP";
    }

    public getPresentation(): void {
        const flashPos:number = this.reelRevealIndex;

        JumpingWildCollector.instance.indicatorState(0);

        if(flashPos == SanEngineManager.AllReels.length) {
            const allBars:Revealer[] = RevealerManager.getAllBars();
            let expanded:boolean = false;
            for(let r:number = 0; r < allBars.length; r++){
                if(allBars[r].state.equal(ReavealerState.EXPANDING) && allBars[r].isActive && !allBars[r].isRevealed){
                    this.pTimeline.add(allBars[r].expandRes(true,0),0);
                    expanded = true;
                }
            }

            const expandDelay:number = expanded ? (this.gameData.singleWin > 0 ? 0.4 : 0) : 0;
            XWaysCounter.instance.setValue(undefined,this.gameData.rawData.totalWays,0.15);
            if(this.gameData.singleWin > 0){
                for (let reel = 0; reel < this.gameData.allWinData.reelWinPositions.length; reel++) {
                    let posRow: boolean[] = this.gameData.allWinData.reelWinPositions[reel];
                    for (let row = 0; row < posRow.length; row++) {
                        const toAlpha:number = posRow[row] ? 0 : 0.4;
                        if (row == 0 || row == posRow.length - 1){
                            const bar: Revealer = row == 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel);
                            this.pTimeline.add(() => bar.attentionDarkness(toAlpha,0.3),expandDelay);
                        }
                        else
                            this.pTimeline.add(() => SanEngineManager.getReel(reel).getSymbol(row - 1)!.attentionDarkness(toAlpha,0.3),expandDelay);
                    }
                }
            }else{
                SanEngineManager.RSWindow((reel:number, sym:number) => SanEngineManager.getReel(reel).getSymbol(sym)!.attentionDarkness(0,0.3))
            }

            this.pTimeline.to(this,this.gameData.singleWin > 0 ? 0.2 : 0.1,{});
            this.PresentationState.set(PresentationState.INACTIVE);
            return;
        } 
        
        if(this.gameData!.scatterReelPositions[flashPos] >= 0){
            this.pTimeline.add(ScatterRevealPresentation.barPresentation(flashPos),0);
            SanEngineManager.getReel(flashPos).AllWindowSymbols.forEach((value: IReelSpriteSymbol, index: number, array: IReelSpriteSymbol[]) =>{
                (<SanSpriteSymbol>value).dirrAtt(false)
            });

        }

        this.reelRevealIndex++;
    }

    public static revealBar(revealPos:number):TimelineMax[]{
        const revTop:Revealer = RevealerManager.getTopBar(revealPos);
        const revBott:Revealer = RevealerManager.getBotBar(revealPos);
        return [revTop.revealRes(), revBott.revealRes()];
    }

    public static BarsActive(revealPos:number):boolean{
        return RevealerManager.getTopBar(revealPos).isActive && RevealerManager.getBotBar(revealPos).isActive;
    }

    public static gotDoubleExpand(revealPos:number):boolean{
        return this.BarsActive(revealPos) && RevealerManager.getBotBar(revealPos).state.equal(ReavealerState.EXPANDING) &&  RevealerManager.getTopBar(revealPos).state.equal(ReavealerState.EXPANDING);
    }

    private static haveRevealed(revealPos:number):boolean{
        return this.BarsActive(revealPos) && RevealerManager.getTopBar(revealPos).isRevealed && RevealerManager.getBotBar(revealPos).isRevealed;
    }

    public static revealTwoMyst(revealPos:number):TimelineMax{
        const tl = new TimelineMax();

        const revTop:Revealer = RevealerManager.getTopBar(revealPos);
        const revBott:Revealer = RevealerManager.getBotBar(revealPos);
        if(revTop.isExpanded && revBott.isExpanded) {
            return tl;
        };

        const revDurr:number = RevealerManager.FullRevealer(revealPos).revealDurr;
        const durrExp: number = SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.EXPAND! + 1;

        tl.add([
            () => revTop.expand(true),
            () => revBott.expand(true),
            () => SoundManager.playSoundEffect(SoundConfig.instance.XWAYS_DOUBLE) 
        ],0);

        tl.add([
            () => RevealerManager.FullRevealer(revealPos).reveal(),
            () => revBott.expandRes(true,revDurr/5,0.1),
            () => revTop.expandRes(true,revDurr/5,0.1),
        ],durrExp);
        tl.to(this,revDurr,{});
        tl.add(() => SoundManager.playSoundEffect(SoundConfig.instance.XWAY_REVEAL_DOUBLE),durrExp + revDurr/3);
        return tl;
    }

    public static barPresentation(revealPos:number,revealed:boolean = false):TimelineMax{
        const tl:TimelineMax = new TimelineMax();

        const revTop:Revealer = RevealerManager.getTopBar(revealPos);
        const revBott:Revealer = RevealerManager.getBotBar(revealPos);

        if(this.haveRevealed(revealPos)){
            tl.to(this, revBott.animTl.duration() - revBott.animTl.time(),0)
            return tl;
        } 

        if(!revealed){
            revTop.setBounceSound(false);
            tl.add( this.revealBar(revealPos), 0);
        } 
       
        if(revTop.state.equal(ReavealerState.NORMAL) && revBott.state.equal(ReavealerState.NORMAL)) { tl.to(this,0.1,{}); }
        else if(revTop.state.equal(ReavealerState.EXPANDING) && revBott.state.equal(ReavealerState.EXPANDING)){
            tl.add(this.revealTwoMyst(revealPos));
        }else if(revTop.state.equal(ReavealerState.MULTIPLIER) && revBott.state.equal(ReavealerState.MULTIPLIER)){
            const reelSym:SanSpriteSymbol[] = <SanSpriteSymbol[]>SanEngineManager.getReel(revealPos).AllWindowSymbols;
            tl.add(() => revTop.glowMult());
            tl.add(() => revBott.glowMult());
            let revVal:number = revTop.isActive ? revTop.multValue : 0;
            revVal += revBott.isActive ? revBott.multValue : 0;
            for(let k:number = 0; k < reelSym.length;k++){
                if(!reelSym[k].isJumpWild) tl.add(reelSym[k].defineSplit(revVal),0);
            }

            tl.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_SPLIT), 0);
            if(revVal == 4) tl.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_SPLIT), 0.3);

            tl.to(this,0.35,{});
        }
        else{
            if(revBott.state.equal(ReavealerState.EXPANDING)){ // order
                playFeaturePerBar(revBott);
                playFeaturePerBar(revTop);
            }else{
                playFeaturePerBar(revTop);
                playFeaturePerBar(revBott);
            }
        }

        function playFeaturePerBar(revFirst:Revealer):void{
            if(revFirst.state.equal(ReavealerState.MULTIPLIER) && revFirst.isActive){
                tl.add(() => revFirst.glowMult())
                tl.add(revFirst.defineSplit());
                
            }else if(revFirst.state.equal(ReavealerState.EXPANDING) && revFirst.isActive){
                const durrExp: number = SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.EXPAND! + 0.5;
                tl.add(() => {revFirst.expand(true);  SoundManager.playSoundEffect(SoundConfig.instance.XWAYS_SINGLE) });
                tl.to(revFirst,durrExp,{})
            }
        }

        return tl;
    }

    public static flashBar(pos:number): TimelineMax {
        RevealerManager.getBotBar(pos).flashBeforeStop();
        return RevealerManager.getTopBar(pos).flashBeforeStop();
    }

    public static flashBarOnce(pos:number,top:boolean): TimelineMax {
        const rev:Revealer = top ? RevealerManager.getTopBar(pos) : RevealerManager.getBotBar(pos);
        return rev.flashOnce();
    }

    public static flashBarFS(pos:number,top:boolean): TimelineMax {
        const rev:Revealer = top ? RevealerManager.getTopBar(pos) : RevealerManager.getBotBar(pos);
        return rev.flashBeforeStop();
    }

    public static revealBarFS(pos:number ,top:boolean): TimelineMax {
        const rev:Revealer = top ? RevealerManager.getTopBar(pos) : RevealerManager.getBotBar(pos);
        return rev.revealRes();
    }

    // Checks if any reels are still stopping.
    public stopPresentation(): void {
    }
}
